'use strict';

const PassThrough = require('stream').PassThrough;
const mimicResponse = require('mimic-response');

const cloneResponse = response => {
	if (!(response && response.pipe)) {
		throw new TypeError('Parameter `response` must be a response stream.');
	}

	const clone = new PassThrough();
	mimicResponse(response, clone);

	return response.pipe(clone);
};

module.exports = cloneResponse;



//////////////////
// WEBPACK FOOTER
// ../node_modules/clone-response/src/index.js
// module id = ../node_modules/clone-response/src/index.js
// module chunks = 5